import Vue from 'vue'
import App from './App.vue'
import dataV from '@jiaminghi/data-view';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import * as echarts from 'echarts';

import $ from 'jquery';
Vue.prototype.$ = $
import axios from 'axios';
import VueAxios from 'vue-axios';
Vue.use(VueAxios,axios)
Vue.use(dataV)
Vue.use(ElementUI)
Vue.config.productionTip = false
Vue.prototype.$echarts = echarts

new Vue({
  render: h => h(App),
}).$mount('#app')
